/**
 * Celoxis API Client
 * Frontend API for Celoxis integration endpoints
 */

import { API_BASE_URL } from './config'

const BASE_URL = `${API_BASE_URL}/external-risks`

/**
 * Celoxis project info (from Celoxis API)
 */
export interface CeloxisProject {
  id: string           // Celoxis internal ID
  name: string         // Project name (e.g., "SpaceX")
  code: string | null  // Project number (e.g., "PRO-271")
  status: string | null
  clientName: string | null
}

/**
 * Celoxis connection status
 */
export interface CeloxisConnectionStatus {
  connected: boolean
  error?: string
}

/**
 * Fetch all projects from Celoxis API
 */
export async function getCeloxisProjects(): Promise<CeloxisProject[]> {
  const response = await fetch(`${BASE_URL}/celoxis-projects`)
  if (!response.ok) {
    throw new Error('Failed to fetch Celoxis projects')
  }
  const data = await response.json()
  return data.data || []
}

/**
 * Search Celoxis projects by name or code
 */
export async function searchCeloxisProjects(query: string): Promise<CeloxisProject[]> {
  const response = await fetch(`${BASE_URL}/celoxis-projects/search?q=${encodeURIComponent(query)}`)
  if (!response.ok) {
    throw new Error('Failed to search Celoxis projects')
  }
  const data = await response.json()
  return data.data || []
}

/**
 * Check Celoxis API connection status
 */
export async function checkCeloxisConnection(): Promise<CeloxisConnectionStatus> {
  const response = await fetch(`${BASE_URL}/celoxis-connection`)
  if (!response.ok) {
    throw new Error('Failed to check Celoxis connection')
  }
  const data = await response.json()
  return data.data
}
